module.exports = { src: __webpack_public_path__ + "media/tile-1-image.8983a862.webp", width: 540, height: 375 };